<template>
  <div>
    <div class="bind_preamble_box">
      <div class="form_item item">
        <p>{{ $t('home.yinjicode') }}</p>
        <!-- <input type="text"
               placeholder="请输入您想要绑定账号的引继码"
               v-model="preamble_code"> -->
        <div id="preamble_code">{{ preamble_code }}</div>
        <span class="btn btn2"
              id="btn"
              @click="copy">{{$t('preamble.tx15')}}</span>
      </div>
      <div class="form_item item">
        <p>{{$t('preamble.tx6')}} <span>{{$t('preamble.tx14')}}</span></p>
        <input type="text"
               :disabled=!pswFla
               v-model="psw"
               :placeholder="$t('preamble.tx8')">
        <span class="btn btn1"
              @click="setPsw"
              v-show="pswFla">{{$t('toast.comfirmBtn1')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { set_preamble_code_password } from '@/api/login'
import { getSessionStorage } from '@/utils/stage'
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      configData: '',
      accountStorage: '',
      preamble_code: '',
      preamble_code_password: '',
      psw: '',
      pswFla: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.accountStorage = JSON.parse(getSessionStorage('preambleInfo'))
      this.configData = JSON.parse(getSessionStorage('message'))
      const preamblecode = JSON.parse(getSessionStorage('preamblecode'))
      this.preamble_code = preamblecode.preamble_code
      this.psw = preamblecode.preamble_code_password
        ? preamblecode.preamble_code_password
        : ''
      this.pswFla = preamblecode.preamble_code_password ? false : true
      //   this.getInfo()
    },
    setPsw() {
      const access_token = this.accountStorage.access_token
      const data = {
        access_token,
        password: this.psw,
      }
      const msg = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        data
      )
      set_preamble_code_password(msg).then((res) => {
        this.pswFla = false
        this.$toast(this.$t('preamble.tx7'))
      })
    },
    //粘贴板方法
    initClipboard(copyDom) {
      const text = this.preamble_code
      let clipboard = new Clipboard(copyDom, {
        text: function () {
          return text //复制的内容
        },
      })
      clipboard.on('success', (e) => {
        this.$toast(this.$t('preamble.tx17'))
        console.log('复制成功!', 'success')
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        this.$toast(this.$t('preamble.tx18'))
        console.log('该浏览器不支持自动复制!', 'warning')
        clipboard.destroy()
      })
    },
    //点击复制
    copy() {
      this.initClipboard('#btn')
    },
  },
}
</script>
  
  <style lang="less" scoped>
.bind_preamble_box {
  width: 100%;
  padding: 30/75rem;
  .item {
    position: relative;
  }
  .form_item {
    p {
      font-weight: bold;
      font-size: 28/75rem;
      color: #575757;
      margin-bottom: 10/75rem;
      span {
        font-size: 20/75rem;
        color: #959595;
      }
    }
    #preamble_code {
      border: 1px solid #575757;
      outline: none;
      width: 467/75rem;
      height: 79/75rem;
      display: block;
      margin-left: 20/75rem;
      border-radius: 6/75rem;
      font-size: 25/75rem;
      text-indent: 15/75rem;
      margin-bottom: 40/75rem;
      line-height: 79/75rem;
    }
    input {
      border: 1px solid #575757;
      outline: none;
      width: 467/75rem;
      height: 79/75rem;
      display: block;
      margin-left: 20/75rem;
      border-radius: 6/75rem;
      font-size: 25/75rem;
      text-indent: 15/75rem;
      margin-bottom: 40/75rem;
      background: #fff;
    }
    .btn {
      width: 153/75rem;
      height: 55/75rem;
      font-size: 26/75rem;
      border-radius: 6/76rem;
      line-height: 55/75rem;
      text-align: center;
      color: #454545;
      display: block;
      background: #f2f3f4;
      position: absolute;
      right: 75/75rem;
      top: 65/75rem;
    }
    .btn1 {
      background: #ff7391;
      color: #fff;
    }
  }
}
</style>